export const referals = [
  {
    pl: {
      title: "Szczerze doceniam",
      author: "Egil B.",
      company: "A. - Producent urządzeń dla niedosłyszących dzieci",
      body: "Jestem bardzo podekscytowany naszym projektem i postępami, które robimy. Przy tych postępach jestem przekonany, że ukończymy produkty na czas. Dziękuję za ciężką pracę i poświęcenie. Szczerze doceniam 👍",
    },
    en: {
      title: "Truly appreciated",
      author: "Egil B.",
      company: "A. - Hearing aid company",
      body: "I'm overly excited about our project and the nice progress we're making. With this progess I feel quite convinced we'll complete the products in time. Thanks for your hard work and dedication. Truly appreciated 👍",
    },
  },
  {
    pl: {
      title: "Rzetelny partner",
      author: "Agnieszka K.",
      company: "Alloweat - startup z branży dietetycznej",
      body: "Na podstawie dotychczasowego doświadczenia ze współpracy możemy zapewnić, że jest to partner rzetelny, podejmujący świadome i odpowiednie decyzje oraz działający zgodnie z najnowocześniejszymi standardami.",
    },
    en: {
      title: "Reliable Partner",
      author: "Agnieszka K.",
      company: "Alloweat - a dietary startup",
      body: "Based on our experience so far, we can assure that this is a reliable partner, making informed and appropriate decisions, and operating in accordance with the latest standards.",
    },
  },
  {
    pl: {
      title: "Cenimy profesjonalne relacje",
      author: "Tomek R.",
      company: "NAOKKO - startup z braży meblarskiej",
      body: "Chętnie rekomendujemy współpracę z Blues Brackest, ponieważ bardzo cenimy profesjonalne relacje oraz umiejętność działania odpowiedzialnie, systematycznie, szybko i trafnie.",
    },
    en: {
      title: "We Value Professional Relationships",
      author: "Tomek R.",
      company: "NAOKKO - a furniture industry startup",
      body: "We are happy to recommend working with Blues Brackets because we highly value their professional relationships and their ability to act responsibly, systematically, quickly, and accurately.",
    },
  },
  {
    pl: {
      title: "Dbałość o szczegóły",
      author: "Michał B.",
      company: "Codelab - software house",
      body: "Niniejszym listem pragnę udzielić referencji firmie Blues Brackets za sumienną i pełną zaangażowania pracę nad projektami, które zostały wykonane z dbałością o najmniejsze szczegóły oraz godną podziwu terminowością.",
    },
    en: {
      title: "Attention to Detail",
      author: "Michał B.",
      company: "Codelab - software house",
      body: "With this letter, I would like to provide a reference for Blues Brackets for their diligent and committed work on projects that were completed with attention to the smallest details and admirable punctuality.",
    },
  },
];
